import type { NavGrant } from '@/lib/navGrant'

let current: string | null = null
let grant: NavGrant | null = null

/**
 * The enterprise the signed-in session is in, for the code that needs it before its first request goes out (a list
 * page restoring its saved choices, #633). The shell sets it when it reads the session; `null` while it is unknown.
 */
export function setSessionEnterprise(id: string | null): void {
    current = id
}

/** The enterprise id set by `setSessionEnterprise`, or `null` while the session's enterprise is unknown. */
export function sessionEnterpriseId(): string | null {
    return current
}

/**
 * What the signed-in person holds in that enterprise: the same grant the shell hands the router (#622), for a screen
 * that must not offer a link the router would turn away (PR #991). The shell sets it when it reads the session.
 */
export function setSessionGrant(next: NavGrant | null): void {
    grant = next
}

/** The grant set by `setSessionGrant`, or `null` while it is unknown; `grantCovers` restricts nothing on `null`. */
export function sessionGrant(): NavGrant | null {
    return grant
}
